import React from "react";
import { Container } from "react-bootstrap";
import { injectIntl } from "react-intl";
import ProfileCard from "../../components/ProfileCard/ProfileCard";
import getPaymentMethodsQuery from './getAllPaymentMethods.graphql';
import getPaymentMethod from './getPaymentMethod.graphql';
import useQueryResponse from "../../lib/hooks/useQueryResponse";
import PaymentMethodForm from "../../components/PaymentMethodForm/PaymentMethodForm";


const PaymentMethodContainer = () => {
    const { data: paymentMethods, loading: paymentMethodLoading } = useQueryResponse({
        query: getPaymentMethodsQuery,
        fetchPolicy: 'network-only',
        ssr: false
    })
    const { data: userPaymentMethod, loading: userPaymentMethodLoading } = useQueryResponse({
        query: getPaymentMethod,
        fetchPolicy: 'network-only',
        ssr: false

    })
    let initialValues = {
        paymentMethodId: userPaymentMethod?.getPaymentMethod?.result?.preferredPaymentMethod.toString(),
    };
    return (
        <div className={'subPageContainer'}>
            <Container>
                <div className='subPageWrapper'>
                    <ProfileCard />
                    <PaymentMethodForm paymentMethodLoading={paymentMethodLoading} paymentMethods={paymentMethods} userPaymentMethod={userPaymentMethod} initialValues={initialValues} />
                </div>
            </Container>
        </div>
    )
}
export default injectIntl(PaymentMethodContainer)